<div class="content">
  <div class="container-fluid">
    <div class="page-content overview">
      <section>
        <div class="overview-title">
          <h5 class="black font-bold">All</h5>
          <small>{{refreshTime | date: preferenceService.dateFormat + ' HH:mm:ss'}}</small>
        </div>
        <p-selectButton [options]="devicesTypeCount" optionLabel="label" class="status" [(ngModel)]="selectedStatus" (onChange)="statusChanged($event)" [allowEmpty]="false">
          <ng-template #item let-item>
            <div class="card flex {{item.label}}">
              <ng-container *ngIf="item.label">
                <div class="avatar" *ngIf="item.label !== 'All'">
                  <i class="fa"></i>
                </div>
                <div class="text" [ngClass]="{'text-align-left': item.label === 'All'}">
                  <h5>{{item.title}}</h5>
                  <p>{{ item.label === 'All' ? 'Total Devices' : item.label }}</p>
                </div>
              </ng-container>
              <ng-container *ngIf="!item.label">
                <div class="avatar">
                  <p-skeleton shape="circle" width="36px" height="36px"></p-skeleton>
                </div>
                <div class="text loaing">
                  <h5>
                    <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 15, 'background-color': '#e9eef0'}"></p-skeleton>
                  </h5>
                  <p>
                    <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 9, 'background-color': '#e9eef0'}"></p-skeleton>
                  </p>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </p-selectButton>
        <div class="row" *ngIf="devicesTypeCount.length === 0 || devicesTypeCount_Region.length !== 0 && pageLoading">
          <div class="col-md" *ngFor="let item of devicesTypeCountGrid">
            <div class="card flex">
              <div class="avatar">
                <p-skeleton shape="circle" width="36px" height="36px"></p-skeleton>
              </div>
              <div class="text loaing">
                <h5>
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 15, 'background-color': '#e9eef0'}"></p-skeleton>
                </h5>
                <p>
                  <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 9, 'background-color': '#e9eef0'}"></p-skeleton>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="pading-top-15">
        <div class="overview-title">
          <h5 class="black font-bold">Alert Per Company</h5>
        </div>
        <div class="row">
          <div class="col-lg-2 col-sm-12">
            <div class="main-side">
              <h5 class="main-side-title" translate>Company</h5>
              <div class="content-list">
                <p-treeTable [value]="treeRegion" selectionMode="single" [(selection)]="selectedRegion" (onNodeSelect)="onRegionSelect($event)"
                  (onNodeUnselect)="onRegionUnselect($event)" (selectionChange)="selectionChange()">
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                    <tr [ttSelectableRow]="rowNode" [ngClass]="{'critical': rowData.criticalCount > 0 || rowData.warningCount > 0 && rowData.criticalCount > rowData.warningCount,
                      'warning': rowData.criticalCount > 0 || rowData.warningCount > 0 && rowData.warningCount >= rowData.criticalCount}">
                      <td style="width:160px" class="col-nowrap ellipsis">
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        <span title="{{rowData.RegionName}}">{{rowData.RegionName}}</span>
                      </td>
                      <td style="width:60px"><span class="badge badge-pill badge-light">{{rowData.totalCount}}</span></td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr *ngIf="devicesTypeCount_Region.length !== 0">
                      <td translate>No Data found</td>
                    </tr>
                    <ng-container *ngIf="devicesTypeCount_Region.length === 0">
                      <tr *ngFor="let item of devicesTypeCountGrid_Region">
                        <td><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton></td>
                      </tr>
                    </ng-container>
                  </ng-template>
                </p-treeTable>
              </div>
            </div>
          </div>
          <div class="col-lg-10 col-sm-12 main-content">
            <div class="content-area">
              <div class="row flex-wrap-nowrap">
                <div class="col-md">
                  <section class="board">
                    <div class="board-header warning">
                      <h5 class="board-title">
                        <span>Warning</span>
                        <span class="board-issue-count">{{deviceWarningList.length}}</span>
                      </h5>
                      <div class="board-search search">
                        <input type="text" pInputText [(ngModel)]="warningKeyWord" placeholder="{{'Search' | translate}}" class="pInputText" (ngModelChange)="searchKeyWord('warning')" >
                      </div>
                    </div>
                    <div div class="board-body border-radius-bottom scroll" [style.height]="boardListHeight">
                      <p-table class="deviceTable boardTable" [value]="deviceWarningList" selectionMode="single" [(selection)]="selectedWaringDevice"
                        (onRowSelect)="onRowSelect($event,'warning')" (onRowUnselect)="onRowUnselect($event)">
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                          <tr [pSelectableRow]="rowData">
                            <td style="width: 100px" class="col-nowrap">
                              <div class="device-content {{rowData.status}}">
                                <div class="device-img">
                                  <div class="img-size">
                                    <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="rowData.image" (error)="errorHandler($event)">
                                  </div>
                                </div>
                                <div class="device-info">
                                  <div class="device-title">
                                    <div class="name">
                                      <h5> {{rowData.name}}</h5>
                                    </div>
                                    <div class="badge badge-secondary hidden-sm">
                                      <span>{{rowData.displayTag}}</span>
                                    </div>
                                  </div>
                                  <div class="device-desc">{{rowData.desc | translate}}</div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td>
                              <div translate class="ui-emptymessage" *ngIf="devicesTypeCount_Region.length !== 0 && !pageLoading else emptyDeviceLoading">No Device found</div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </section>
                </div>
                <div class="col-md">
                  <section class="board">
                    <div class="board-header critical">
                      <h5 class="board-title">
                        <span>Critical</span>
                        <span class="board-issue-count">{{deviceCriticalList.length}}</span>
                      </h5>
                      <div class="board-search search">
                        <input type="text" pInputText [(ngModel)]="criticalKeyWord" placeholder="{{'Search' | translate}}" class="pInputText" (ngModelChange)="searchKeyWord('critical')">
                      </div>
                    </div>
                    <div class="board-body border-radius-bottom scroll" [style.height]="boardListHeight">
                      <p-table class="deviceTable boardTable" [value]="deviceCriticalList" selectionMode="single" [(selection)]="selectedCriticalDevice"
                        (onRowSelect)="onRowSelect($event,'critical')" (onRowUnselect)="onRowUnselect($event)">
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                          <tr [pSelectableRow]="rowData">
                            <td style="width: 100px" class="col-nowrap">
                              <div class="device-content {{rowData.status}}">
                                <div class="device-img">
                                  <div class="img-size">
                                    <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="rowData.image" (error)="errorHandler($event)">
                                  </div>
                                </div>
                                <div class="device-info">
                                  <div class="device-title">
                                    <div class="name">
                                      <h5> {{rowData.name}}</h5>
                                    </div>
                                    <div class="badge badge-secondary hidden-sm">
                                      <span>{{rowData.displayTag}}</span>
                                    </div>
                                  </div>
                                  <div class="device-desc">{{rowData.desc | translate}}</div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td>
                              <div translate class="ui-emptymessage" *ngIf="devicesTypeCount_Region.length !== 0 && !pageLoading else emptyDeviceLoading">No Device found</div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  </section>
                </div>
                <div class="col-md">
                  <section class="board m-b-12">
                    <div class="board-header">
                      <h5 class="board-title status">
                        <span>{{ selectedRegion?.data?.RegionName }}</span>
                        <span class="flex-1 padding-left-4">Devices</span>
                        <span class="board-issue-count">{{ selectedRegion?.data?.totalCount || 0 }}</span>
                      </h5>
                    </div>
                    <div class="board-body border-radius-bottom">
                      <div class="board-list">
                        <ng-container *ngFor="let item of devicesTypeCount_Region">
                          <div class="board-list-status" *ngIf="item.label !== 'All'">
                            <div class="board-list-content {{ item.label }}">
                              <div class="status-text">
                                <p class="label">{{ item.label }}</p>
                                <a role="button" tabindex="0" style="color: black; cursor: pointer;" (click)="linkToDeviceMontioring(item); $event.preventDefault()">{{ item.title }} <i class="fa fa-angle-right"></i></a>
                              </div>
                              <p-progressBar [value]="item.title / (selectedRegion?.data?.totalCount || 1) * 100" [showValue]="false"></p-progressBar>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="devicesTypeCount_Region.length === 0">
                          <ng-container *ngFor="let item of devicesTypeCountGridLoaing">
                            <div class="board-list-status">
                              <div class="board-list-content {{ item.label }}">
                                <div class="p-m-4">
                                  <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 20, 'background-color': '#e9eef0'}"></p-skeleton>
                                </div>
                                <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 7, 'background-color': '#e9eef0'}"></p-skeleton>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </section>
                  <section class="board">
                    <div class="board-header">
                      <h5 class="board-title">
                        <span>Events (24h)</span>
                      </h5>
                      <div class="board-search search">
                        <input type="text" pInputText placeholder="{{'Search' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
                      </div>
                    </div>
                    <div class="board-body scroll" [style.height]="eventListHeight">
                      <p-table #dt class="deviceTable" [value]="eventLogs" [columns]="eventLogs_cols" [globalFilterFields]="['name','desc']" selectionMode="single"
                        [(selection)]="selectedEvent" (onRowSelect)="onRowEventSelect($event)" (onRowUnselect)="onRowEventUnselect($event)">
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                          <tr [pSelectableRow]="rowData">
                            <td style="width: 100px" class="col-nowrap">
                              <div class="events flex">
                                <div class="events-icon">
                                  <span class="center" *ngIf="!rowData.isHardwareFault">
                                    <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
                                  </span>
                                  <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
                                  </div>
                                </div>
                                <div class="events-text">
                                  <div class="events-title">
                                    <div class="events-title-name">{{rowData.name}}</div>
                                    <div>{{rowData.timeformat | date: 'yyyy/MM/dd HH:mm:ss' }}</div>
                                  </div>
                                  <div class="events-desc">{{rowData.desc}}</div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td [ngClass]="{'pageLoadingTd': devicesTypeCount_Region.length === 0 && pageLoading}">
                              <div translate class="ui-emptymessage" *ngIf="devicesTypeCount_Region.length !== 0 && !pageLoading else emptyEventLoading">No Event found</div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                    <div class="board-footer">
                      <div class="link">
                        <a role="button" tabindex="0" style="color: black; cursor: pointer;" (click)="linkToEventMontioring(); $event.preventDefault()">{{'Check Events' | translate}} <i class="fa fa-angle-right"></i></a>
                        <!-- <button pButton icon="fa fa-angle-right"></button> -->
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>


<p-drawer [(visible)]="deviceDetailSidebar" position="right" [baseZIndex]="10000" styleClass="overview-detail" [modal]="false" (onHide)="onDeviceDetailHide();">
  <div class="sidebar-content">
    <div class="sidebar-content-title">
      <h5>{{'Device Status' | translate}}</h5>
    </div>
    <div class="sidebar-content-body">
      <div class="sidebar-content-detail {{deviceDetail.status}}">
        <div class="sidebar-content-detail-img">
          <!-- <img class="responsive-image" [defaultImage]="'/assets/images/default_device.png'" [lazyLoad]="deviceDetail.image" (error)="errorHandler($event)"> -->
          <img class="responsive-image {{deviceDetail.imageClass}}" src="{{deviceDetail.image}}" (error)="errorHandler($event)">
        </div>
        <div class="sidebar-content-detail-info">
          <div class="sidebar-content-detail-info-title">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" *ngIf="deviceDetail.hardwarefault && deviceDetail.hardwarefault.isHardwareFault"></i>
            <h5>{{deviceDetail.name}}</h5>
          </div>
          <div class="sidebar-content-detail-info-desc">
            {{deviceDetail.desc | translate}}
          </div>
        </div>
        <div class="status-info">
          <div class="status-info-row" *ngIf="deviceDetail.subtype === 'UPS' || deviceDetail.subtype === '3-Phase UPS'">
            <div class="status-info-list" *ngIf="deviceDetail.hardwarefault && deviceDetail.hardwarefault.isHardwareFault">
              <div class="infoBox">
                <div class="icon errorCodeIcon">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': deviceDetail.hardwarefault.faultLevelColor}"></i>
                </div>
                <div class="info">
                  <p translate>Hardware Status</p>
                  <h6>
                    <span>{{deviceDetail.hardwarefault.faultCodeStr}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype !== '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-plug" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Power source</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.PowSour else noData_span">{{(deviceDetails$ | async)?.PowSour | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list">
              <div class="infoBox">
                <div class="icon battery" [ngClass]="{'alert-color': (batteryReplacementInfo.expires)}">
                  <p-progressBar [value]="(deviceDetails$ | async)?.BatCap" [showValue]="false"></p-progressBar>
                  <i class="fa fa-battery-empty" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Battery Capacity</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.BatCap !== null && (deviceDetails$ | async)?.BatCap !== undefined) else noData_span">{{(deviceDetails$ | async)?.BatCap}} %</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype !== '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Output Voltage</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.OutVolt else noData_span">{{(deviceDetails$ | async)?.OutVolt}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Output Voltage-A/B/C</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltA !== null && (deviceDetails$ | async)?.OutVoltA !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltA}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltB !== null && (deviceDetails$ | async)?.OutVoltB !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltB}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.OutVoltC !== null && (deviceDetails$ | async)?.OutVoltC !== undefined) else noData_span">{{(deviceDetails$ | async)?.OutVoltC}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === '3-Phase UPS'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-line-chart" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>UPS Load-A/B/C</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctA !== null && (deviceDetails$ | async)?.LoadPctA !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctA}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctB !== null && (deviceDetails$ | async)?.LoadPctB !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctB}}</span>
                    <span> / </span>
                    <span *ngIf="((deviceDetails$ | async)?.LoadPctC !== null && (deviceDetails$ | async)?.LoadPctC !== undefined) else noData_span">{{(deviceDetails$ | async)?.LoadPctC}} %</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.sourcetype !== SourceType['Gateway']">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Estimated Time</p>
                  <h6>
                    <span *ngIf="(deviceDetails$ | async)?.BatRun else noData_span">{{(deviceDetails$ | async)?.BatRun}} {{'minutes' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="status-info-row" *ngIf="deviceDetail.subtype !== 'UPS' && deviceDetail.subtype !== '3-Phase UPS'">
            <div class="status-info-list" *ngIf="deviceDetail.hardwarefault && deviceDetail.hardwarefault.isHardwareFault">
              <div class="infoBox">
                <div class="icon errorCodeIcon">
                  <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': deviceDetail.hardwarefault.faultLevelColor}"></i>
                </div>
                <div class="info">
                  <p translate>Hardware Status</p>
                  <h6>
                    <span>{{deviceDetail.hardwarefault.faultCodeStr}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === 'nATS' || deviceDetail.subtype === 'nPDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    lightbulb
                  </span>
                </div>
                <div class="info">
                  <p translate>Total Power</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.PowerT !== null && (deviceDetails$ | async)?.PowerT !== undefined) else noData_span">{{(deviceDetails$ | async)?.PowerT}} {{'W' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === 'nATS' || deviceDetail.subtype === 'nPDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    model_training
                  </span>
                </div>
                <div class="info">
                  <p translate>Total Energy</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.EnergyT !== null && (deviceDetails$ | async)?.EnergyT !== undefined) else noData_span">{{(deviceDetails$ | async)?.EnergyT}} {{'kWh' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-bolt" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Current</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Cur !== null && (deviceDetails$ | async)?.Cur !== undefined) else noData_span">{{(deviceDetails$ | async)?.Cur | translate}} {{'A' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <i class="fa fa-plug" aria-hidden="true"></i>
                </div>
                <div class="info">
                  <p translate>Voltage</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Volt !== null && (deviceDetails$ | async)?.Volt !== undefined) else noData_span">{{(deviceDetails$ | async)?.Volt}} {{'volts' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === 'ATS' || deviceDetail.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    lightbulb
                  </span>
                </div>
                <div class="info">
                  <p translate>Power</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Power !== null && (deviceDetails$ | async)?.Power !== undefined) else noData_span">{{(deviceDetails$ | async)?.Power}} {{'W' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
            <div class="status-info-list" *ngIf="deviceDetail.subtype === 'ATS' || deviceDetail.subtype === 'PDU'">
              <div class="infoBox">
                <div class="icon">
                  <span class="material-icons">
                    model_training
                  </span>
                </div>
                <div class="info">
                  <p translate>Energy</p>
                  <h6>
                    <span *ngIf="((deviceDetails$ | async)?.Energy !== null && (deviceDetails$ | async)?.Energy !== undefined) else noData_span">{{(deviceDetails$ | async)?.Energy}} {{'kWh' | translate}}</span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Event Logs -->
      <div class="sidebar-content-evnets">
        <div class="sidebar-content-evnets-title">
          <h5 translate>Event Logs</h5>
        </div>
        <div class="sidebar-content-evnets-body">
          <p-table class="deviceTable" [value]="eventLogsDetail" [scrollable]="true" scrollHeight="{{sideEventListHeight}}">
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td style="width: 100px" class="col-nowrap">
                  <div class="events flex">
                    <div class="events-icon">
                      <span class="center" *ngIf="!rowData.isHardwareFault">
                        <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
                      </span>
                      <div class="icon errorCodeIcon" *ngIf="rowData.isHardwareFault">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true" [ngStyle]="{'color': rowData.faultLevelColor}"></i>
                      </div>
                    </div>
                    <div class="events-text">
                      <div class="events-title">
                        <div>{{rowData.timeformat | date: 'yyyy/MM/dd HH:mm:ss' }}</div>
                      </div>
                      <div class="events-desc">{{rowData.desc}}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="1">
                  <div translate class="ui-emptymessage">No Event found</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <button pButton type="button" icon="pi pi-angle-right" iconPos="right" class="ui-button-danger" label="{{'View Detail' | translate}}" (click)="routeToDetailPage();"></button>
  </div>
</p-drawer>

<ng-template #noData_span>
  <span>--</span>
</ng-template>

<ng-template #emptyDeviceLoading>
  <div class="loading">
    <div class="device-content" *ngFor="let item of devicesTypeCountGrid_Region">
      <div class="device-img">
        <div class="img-size">
          <p-skeleton size="3rem" class="mr-2"></p-skeleton>
        </div>
      </div>
      <div class="device-info">
        <div class="device-title">
          <div class="name">
            <h5><p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton></h5>
          </div>
        </div>
        <div class="device-desc"><p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emptyEventLoading>
  <div class="loading" *ngFor="let item of devicesTypeCountGrid_Region">
    <div class="events flex">
      <div class="events-icon">
        <div class="icon">
          <p-skeleton shape="circle" width="20px" height="20px"></p-skeleton>
        </div>
      </div>
      <div class="events-text">
        <div class="events-title">
          <div class="events-title-name">
            <p-skeleton appearance="line" [theme]="{ 'width': '100%','height.px': 16, 'background-color': '#e9eef0'}"></p-skeleton>
          </div>
        </div>
        <div class="events-desc">
          <p-skeleton appearance="line" [theme]="{ 'width': '80%','height.px': 12, 'background-color': '#e9eef0'}"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
</ng-template>
